import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { APP_CONFIG } from '../config/settings';

interface IdleTimerProps {
  onTimeout: () => void;
}

export function IdleTimer({ onTimeout }: IdleTimerProps) {
  const { t } = useLanguage();
  const [timeLeft, setTimeLeft] = useState<number>(APP_CONFIG.IDLE_COUNTDOWN_DURATION);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          onTimeout();
          return prev; // Don't restart the timer
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [onTimeout]);

  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');

  return (
    <div className="idle-timer">
      {t('countdown')} {minutes}:{seconds}
    </div>
  );
}